export function hasMultipleUrls(url: string) {
  const regex = /https?:\/\//g;

  const matches = (
    url.startsWith('https://') || url.startsWith('http://')
      ? url
      : `https://${url}`
  ).match(regex);

  return matches?.length > 1;
}
